import React from 'react'
import { MessageBox, Message, Button } from 'element-react'

const MessageBoxSG = () => {
    const onClick = () => {
        MessageBox.confirm(
            'This will permanently delete the file. Continue?',
            'Warning',
            {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning',
            },
        )
            .then(() => {
                Message({
                    type: 'success',
                    customClass: 'el-message--success',
                    iconClass: 'el-message__icon el-icon-circle-check',
                    message: 'Delete completed!',
                })
            })
            .catch(() => {
                Message({
                    type: 'info',
                    customClass: 'el-message--info',
                    iconClass: 'el-message__icon el-icon-information',
                    message: 'Delete canceled',
                })
            })
    }

    return (
        <div>
            <Button type="text" onClick={onClick}>
                Click to open the Message Box
            </Button>
        </div>
    )
}

export default MessageBoxSG
